import { AxiosResponseHeaders } from 'axios';
import { ForecastRouting, ForecastRoutingResponseDTO } from '../entities';

const forecastRoutingDTOToForecastRoutingAdapter = (
  data: ForecastRoutingResponseDTO,
  headers?: AxiosResponseHeaders,
) => {
  if (!data.body) {
    throw new Error('Error');
  }

  const responseData = data.body;

  return new ForecastRouting(responseData.routingSystem, responseData.routingDescription, responseData.routingSn);
};

export { forecastRoutingDTOToForecastRoutingAdapter };
